// utils/helpers.js
// Função simples para dividir um texto em parágrafos (quebra dupla de linha)
export function splitParagraphs(text) {
  return text.split(/\n\s*\n/).map(t => t.trim()).filter(Boolean);
}
